import styles from '../styles'
import { Avatar } from '../../../molecules/Avatar'
import { cn } from 'ethcss'
import { grid } from '../../../theme'
import translate from '../../../core/translate'
import React, { useState } from 'react'
import { getRolesString } from '../index'
import { useDispatch } from 'react-redux'
import { logout, userActions } from 'blocks.app/user/user.state'
import DotTooltip from '../../../blocks.simple/dotTooltip/dotTooltip'
import Icon from '../../../blocks.simple/icon/icon'
import EditText from '../../../blocks.simple/editText/editText'
import Button from '../../../blocks.simple/button/button'
import { api } from '../../../core/api/ConnectionManager'
import helpers from '../../../core/helpers'

const OwnerPanel = (p_) => {
    const dispatch = useDispatch()
    const isAvailable = helpers.isAvailable({ key: 'company', action: 'update' })
    const [companyName, setCompanyName] = useState(p_.user.company.name)
    const [open, setOpen] = useState(false)

    const getUserEmail = () => {
        if (!p_.user.name) {
            return null
        }

        return <div className={styles.email}>{p_.user.email}</div>
    }

    const handleUserLogout = (e) => {
        dispatch(userActions.closeUserPanel())
        dispatch(logout({ isSwitchAccount: false }))
    }

    const onOpen = () => {
        setOpen(true)
    }

    const onClose = () => {
        setOpen(false)
        setCompanyName(p_.user.company.name)
    }

    const onSave = () => {
        if (!isAvailable) return

        api.send('updateCompanyName', { name: companyName }).then(() => {
            p_.updateUserState({
                ...p_.user,
                company: {
                    ...p_.user.company,
                    name: companyName,
                },
            })
            onClose()
        })
    }

    return (
        <div className={styles.ownerPanelWrapper}>
            <div className={styles.ownerPanelAvatar}>
                <Avatar src={p_.user.photo} size={92} />
            </div>
            <div className={styles.ownerPanelInfo}>
                <div className={styles.userInfo}>
                    <div className={styles.username}>{p_.user.name || p_.user.email}</div>
                    {getUserEmail()}
                    <div className={styles.userBlock}>
                        <div className={styles.userBlockCaption}>{translate('idCompany')}:</div>
                        <div className={styles.userBlockText}>{p_.user.company.id}</div>
                    </div>
                    <div className={styles.userBlock}>
                        <div className={styles.userBlockCaption}>{translate('companyName')}:</div>
                        <div className={styles.userBlockText}>
                            <DotTooltip
                                tooltip={{
                                    html: p_.user.company.name,
                                    position: 'right',
                                    disabled: false,
                                    followCursor: true,
                                }}
                                containerClass={cn(styles.textTooltip)}
                            >
                                <div className={styles.textTooltip}>{p_.user.company.name}</div>
                            </DotTooltip>
                            {isAvailable && (
                                <div onClick={onOpen}>
                                    <Icon
                                        type={'pencil'}
                                        color={'grey'}
                                        size={10}
                                        tooltip={{ title: translate('edit') }}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className={styles.roles}>{getRolesString(p_.user.roles)}</div>
                </div>
                <div className={styles.ownerPanelActions}>
                    <div className={cn(styles.ownerPanelAction, grid.mr_md)} onClick={p_.onEditAccount}>
                        {translate('edit')}
                    </div>
                    <div className={styles.ownerPanelAction} onClick={handleUserLogout}>
                        {translate('exit')}
                    </div>
                </div>
            </div>
            {open && (
                <div className={styles.modal}>
                    <div className={styles.modalInner}>
                        <div className={styles.modalTitle}>Изменение названия компании</div>
                        <EditText
                            noSpaces
                            containerClass={styles.modalTextInput}
                            label={translate('newCompanyName')}
                            value={companyName}
                            placeholder={translate('enterNewCompanyName')}
                            id="startDate"
                            onChange={(name) => {
                                setCompanyName(name)
                            }}
                        />
                        <div className={styles.modalControls}>
                            <Button mod={'withBorder'} className={styles.modalButton} onClick={onClose}>
                                {translate('cancel')}
                            </Button>
                            <Button
                                mod={'fill'}
                                className={styles.modalButton}
                                onClick={onSave}
                                disabled={!companyName}
                            >
                                {translate('save')}
                            </Button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export { OwnerPanel }
